export default __webpack_public_path__ + "static/media/group-8.1098e75a.png";